/* eslint-disable @next/next/no-html-link-for-pages */
import React from "react";
import {
  Box,
  Text,
  Link,
  Stack,
  Heading,
  Flex,
  VStack,
  List,
  ListItem,
} from "@chakra-ui/react";

import { GetNotice } from "../pages/api/base";
import { checkIEAccess } from "../provider/common";

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notice: [],
    };
  }
  componentDidMount() {
    this.notice();
    checkIEAccess();
  }

  notice = async () => {
    const notice = await GetNotice();
    this.setState({ notice: notice });
  };

  render() {
    return (
      <Box id="footer_pc">
        <footer>
          <Box className="ft_logo mobile">
            <a href="/">
              <img src="/images/pandalogo.png" width="120px" height="auto" />
            </a>
          </Box>
          <Box className="ft_lft">
            <Box className="ft_logo">
              <a href="/">
                <img src="/images/pandalogo.png" width="120px" height="auto" />
              </a>
            </Box>
            <Box className="ft_address">
              <p>
                <span> 파츠고(주) 대표이사 : 이종철 </span>
                <b>|</b>
                <span>
                  서울특별시 강남구 테헤란로82길 15 (대치동 942-15) 디아이타워
                  5층
                </span>
              </p>
              <p>
                <span>사업자등록번호 : 557-81-00960</span> <b>|</b>
                <span> 통신판매업 신고번호 : 2021-서울강남-06663호</span>
                <b>|</b>
                <span> 상표권 등록번호 : 제40-1705579호</span>
              </p>
              <p>
                <span> 부가통신사업 신고번호 : 제2-01-19-0130호 </span> <b>|</b>
                <span>호스팅서비스 제공자 : 파츠고 주식회사</span> <b>|</b>
                <span>전화번호 : 070-4742-4989</span>
              </p>
            </Box>
            <Box className="ft_menu">
              <Box>Copyright © 2025 PARTSGO</Box>
              <ul>
                <li>
                  <a href="/board/home?status=privacy">개인정보처리방침</a>
                </li>
                <li>
                  <a href="/board/home?status=terms">이용약관</a>
                </li>
                <li>
                  <a
                    href="https://www.ftc.go.kr/www/bizCommList.do?key=232"
                    target="_blank"
                    rel="noreferrer"
                  >
                    사업자정보확인
                  </a>
                </li>
                <li>
                  <a
                    href="https://mark.inicis.com/mark/escrow_popup.php?mid=pandapart1"
                    target="_blank"
                    rel="noreferrer"
                  >
                    에스크로가입확인
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.ilogen.com/web/reservation/returns"
                    target="_blank"
                    rel="noreferrer"
                  >
                    AS배송예약
                  </a>
                </li>
              </ul>
            </Box>
          </Box>
          <Box className="ft_rt">
            <div>
              <h3>무엇을 도와드릴까요?</h3>
              <p>
                <span>평일(월~목)</span>
                <b>09:00 ~ 18:00</b>
              </p>
              <p>
                <span>평일(금요일)</span>
                <b>09:00 ~ 17:00</b>
                <span className="except">(주말 및 공휴일 휴무)</span>
              </p>
              <p>
                <span> 점심시간</span>
                <b>12:30 ~ 13:30</b>
              </p>
            </div>
          </Box>

          <Box className="ft_menu mobile">
            <ul>
              <li>
                <a href="/board/home?status=privacy">개인정보처리방침</a>
              </li>
              <li>
                <a href="/board/home?status=terms">이용약관</a>
              </li>
              <li>
                <a
                  href="https://www.ftc.go.kr/www/bizCommList.do?key=232"
                  target="_blank"
                  rel="noreferrer"
                >
                  사업자정보확인
                </a>
              </li>
              <li>
                <a
                  href="https://mark.inicis.com/mark/escrow_popup.php?mid=pandapart1"
                  target="_blank"
                  rel="noreferrer"
                >
                  에스크로가입확인
                </a>
              </li>
              <li>
                <a
                  href="https://www.ilogen.com/web/reservation/returns"
                  target="_blank"
                  rel="noreferrer"
                >
                  AS배송예약
                </a>
              </li>
            </ul>
            <Box>Copyright © 2025 PARTSGO</Box>
          </Box>
        </footer>
      </Box>
    );
  }
}
